import React from 'react';
import { CopyOutlined } from '@ant-design/icons';
import { message, Tooltip } from 'antd';

interface CopyButtonProps {
  textToCopy: string;
  tooltip?: string;
  className?: string;
  style?: React.CSSProperties;
}

const CopyButton: React.FC<CopyButtonProps> = ({
  textToCopy,
  tooltip = 'Copy',
  className,
  style,
}) => {
  const handleCopy = () => {
    if (!textToCopy) {
      message.error('Nothing to copy');
      return;
    }
    navigator.clipboard.writeText(textToCopy)
      .then(() => message.success('Copied to clipboard!'))
      .catch(() => message.error('Failed to copy'));
  };

  return (
    <Tooltip title={tooltip}>
      <CopyOutlined
        className={className}
        style={{ cursor: 'pointer', ...style }}
        onClick={handleCopy}
      />
    </Tooltip>
  );
};

export default CopyButton;
